<template>
	<v-container fluid class="full-header-container px-4 py-2">
		<!-- Mobile -->
		<div v-if="$vuetify.breakpoint.mobile" class="header-row">
			<div class="header-cell-icon">
				<v-icon color="#2D4B95"
					@click="$store.menuStore.commit('setMenuSidebarStatus', !$store.menuStore.state.menuSidebarStatus)">mdi-menu</v-icon>
			</div>
			<div class="header-cell-info header-cell-info--grow">
				<HeaderProjectInfoMobile v-if="headerType === 1 || headerType === 99"/>
				<ProjectActionButtons v-if="headerType === 2"/>
				<UserActionButtons v-else-if="actionButtonsType === 2 && checkPermissions(['create_users'])"/>
			</div>
			<div class="header-cell-actions">
				<NotificationHeader />
				<ProjectSidebar v-if="$store.userStore.state.isAuthenticated" />
			</div>
		</div>
		<v-divider v-if="$vuetify.breakpoint.mobile" class="mt-2"></v-divider>

		<!-- Desktop -->
		<div v-else class="header-row">
			<div class="header-cell-info">
				<HeaderProjectInfo v-if="headerType === 1"/>
				<ProjectActionButtons v-if="headerType === 2"/>
				<UserActionButtons v-else-if="actionButtonsType === 2 && checkPermissions(['create_users'])"/>
			</div>
			<div class="header-cell-right">
				<div class="header-cell-search">
					<SearchBarHeader />
				</div>
				<div class="header-cell-actions">
					<NotificationHeader />
					<ProjectSidebar v-if="$store.userStore.state.isAuthenticated" />
				</div>
			</div>
		</div>
	</v-container>
</template>

<script>
import HeaderProjectInfo from './HeaderProjectInfo'
import HeaderProjectInfoMobile from './HeaderProjectInfoMobile'
import ProjectActionButtons from '@/components/Globals/Headers/ActionButtons/ProjectActionButtons'
import SearchBarHeader from './SearchBarHeader'
import NotificationHeader from './NotificationHeader'
import ProjectSidebar from '@/components/Layout/ProjectSidebar/ProjectSidebarIndex'
import UserActionButtons from '@/components/Globals/Headers/ActionButtons/UserActionButtons'
import {checkPermissions} from '@/helpers/permissions'

export default {
	name: 'FullHeader',
	components: {HeaderProjectInfo, HeaderProjectInfoMobile, ProjectActionButtons, SearchBarHeader, NotificationHeader, ProjectSidebar, UserActionButtons},
	props: {
		headerType: {
			type: Number,
			default: 1
		},
		actionButtonsType: {
			type: Number,
			default: 1
		},
	},
	data: () => ({
		//
	}),
	mounted(){
	},
	methods: {checkPermissions}
};
</script>
<style scoped>
	.full-header-container {
		background: #ffffff;
		border-bottom: 1px solid #EAECF4;
	}
	.header-row {
		display: flex;
		align-items: center;
		gap: 8px;
		width: 100%;
	}
	.header-cell-icon {
		flex: 0 0 auto;
	}
	.header-cell-info {
		flex: 0 0 auto;
		min-width: 0;
	}
	.header-cell-right {
		flex: 1 1 0;
		min-width: 0;
		display: flex;
		align-items: center;
		gap: 25px;
		justify-content: flex-end;
	}
	.header-cell-search {
		flex: 1 1 0;
		min-width: 120px;
		max-width: 480px;
	}
	.header-cell-actions {
		flex: 0 0 auto;
		display: flex;
		align-items: center;
		gap: 25px;
	}
	.header-cell-info--grow {
		flex: 1 1 0;
	}
	.sidebar-toggle-btn {
		background: linear-gradient(135deg, #5E85EF 0%, #2D4B95 100%) !important;
		border-radius: 8px !important;
	}
</style>